import { gql } from "@apollo/client";

export const GetTicketForLatestTicketDetail = gql`
  query GetTickets(
    $token: String!
    $after: Cursor
    $first: Int
    $customerID: ID!
    $companyID: ID!
    $subsidiaryID: ID!
    $siteID: ID!
    $input: TicketQuery!
    $orderBy: AtsTicketsOrder
    $startDate: Time
    $endDate: Time
  ) {
    GetTickets(
      token: $token
      after: $after
      first: $first
      orderBy: $orderBy
      customerID: $customerID
      companyID: $companyID
      siteID: $siteID
      subsidiaryID: $subsidiaryID
      input: $input
      startDate: $startDate
      endDate: $endDate
    ) {
      edges {
        node {
          id
          ticketNo
          status
          ticketDate
          reason
          item {
            desc
            manufacturerDetails {
              manufacturer
            }
          }
          loggedUser {
            name
          }

          lastRemarks
          loggedUser {
            name
            empType
            mobile
          }
          priority
          itemDetails {
            id
            prodSerialNo
            currentJunction {
              name
            }
            vendorDetails {
              id
              desc
            }
          }
          orderedDetails {
            id
            companyID
            attendedDate
            remarks
            status
            imagesPath
            ticketID
            itemDetails {
              id
              vendorDetails {
                id
                desc
              }
            }
          }
        }
      }
      totalCount
    }
  }
`;

export const getItemDetailsByNodeForTicket = gql`
  query getItemDetailsByNode($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsStckItemDetails {
        id
        remarks
      }
    }
  }
`;

export const ticketDetailsByNodeId = gql`
  query ticketDetailsByNodeId($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsTicketDetails {
        id
        remarks
        imagesPath
        companyID
        ticketAssetDetails {
          id
          images_path
          remarks
          itemDetails {
            id
            prodSerialNo
            item {
              icon
              desc
            }
          }
        }
      }
    }
  }
`;

export const ExportTickets = gql`
  query ExportTickets(
    $token: String!
    $customerID: ID!
    $companyID: ID!
    $subsidiaryID: ID!
    $siteID: ID!
    $junctionID: ID
    $startDate: Time
    $endDate: Time
    $input: TicketQuery!
    $format: DownloadDocType!
  ) {
    ExportTickets(
      token: $token
      customerID: $customerID
      companyID: $companyID
      subsidiaryID: $subsidiaryID
      siteID: $siteID
      junctionID: $junctionID
      startDate: $startDate
      endDate: $endDate
      input: $input
      format: $format
    )
  }
`;
